import React from 'react';
import {
  Form, FormControl,
} from 'react-bootstrap';
import classnames from 'classnames';
import { CheckboxProps } from 'types/Checkbox';
import { FormRenderFieldType } from 'types/TextField';
import { useTranslation } from 'react-i18next';

function Checkbox( {
  name,
  value,
  label,
  classNames = {},
  onChange,
  isInvalid,
  showErrors = true,
  meta,
  disabled,
  type = 'checkbox',
  translateLabel = true,
  reverse = true,
}: CheckboxProps & FormRenderFieldType ) {
  const { t } = useTranslation();
  return (
    <Form.Group className={classnames( 'form-group', classNames.formGroup, {
      'is-invalid': isInvalid,
    } )}
    >
      <Form.Check
        inline
        reverse={reverse}
        label={translateLabel && typeof label === 'string' ? t( label ) : label}
        checked={value}
        className={classnames( classNames.input, 'switch-generic' )}
        type={type}
        id={name}
        disabled={disabled}
        onChange={( event ) => {
          const val = event.target.checked;
          if ( onChange ) onChange( val, event );
        }}
      />

      {showErrors
      && (
        <FormControl.Feedback type="invalid">
          {isInvalid ? meta?.error || meta?.submitError || ' ' : ''}
        </FormControl.Feedback>
      )}
    </Form.Group>

  );
}

export default Checkbox;
